import type { DisplayModule } from "../dashboard-app/types"

const displayModule: DisplayModule = {
  displays: {}
}

export default displayModule